"use client";
import { formatDate } from "@/lib/time";
import PageTitle from "../layout/PageTitle";
import { Tabs, TabsList, TabsTrigger } from "@clarityos/ui/tabs";
import { startTransition, useEffect, useRef, useState } from "react";
import PageContent from "../layout/PageContent";
import { CardCollectionTable } from "@/features/card-collection/components/CardCollectionTable";
import { useCardCollection } from "@/features/card-collection/hooks/useCardCollection";
import { useCardCollectionCardChangedEvent } from "@/features/card-collection/hooks/useCardCollectionCardChangedEvent";

type Tab = "all" | "noccof";

const CardCollection = () => {
  const [selectedTab, setSelectedTab] = useState<Tab>("all");
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    contentRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedTab]);

  const hasCardFilter = selectedTab === "noccof" ? false : undefined;

  const cardCollection = useCardCollection({
    hasCard: hasCardFilter,
  });

  useCardCollectionCardChangedEvent();

  return (
    <>
      <PageTitle
        title="Card Collection"
        // todo: apply clinic timezone once CPAY-2618 is done
        subtitle={formatDate(new Date(), "eeee, MMM d")}
        bottomContent={
          <div className="flex items-center justify-between gap-4">
            <Tabs
              variant="pill"
              value={selectedTab}
              onValueChange={(value) =>
                startTransition(() => setSelectedTab(value as Tab))
              }
            >
              <TabsList>
                <TabsTrigger
                  value="all"
                  endAdornment={cardCollection.extra?.summary?.totalCount ?? 0}
                >
                  All
                </TabsTrigger>
                <TabsTrigger
                  value="noccof"
                  endAdornment={cardCollection.extra?.summary?.noCardCount ?? 0}
                >
                  No Card on File
                </TabsTrigger>
              </TabsList>
            </Tabs>
          </div>
        }
      />
      <PageContent>
        <CardCollectionTable
          ref={contentRef}
          {...cardCollection}
          isFetching={cardCollection.isRefetchingWithNewParams}
        />
      </PageContent>
    </>
  );
};

export default CardCollection;
